
import { track } from '@marketplace/helpers/segment/index.js'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'

export default {
    name: 'BaseLink',
    props: {
        to: {
            type: [String, Object, null],
            default: null,
        },
        href: {
            type: String,
            default: '',
        },
        tracking: {
            type: Array,
            default: null,
            validator(value) {
                if (!value) {
                    return true
                }

                return isString(value[0]) && isObject(value[1])
            },
        },
        // Support active class for NuxtLink
        exact: {
            type: Boolean,
            default: false,
        },
        exactPath: {
            type: Boolean,
            default: false,
        },
        activeClass: {
            type: String,
            default: '',
        },
        disableActiveClass: {
            type: Boolean,
            default: false,
        },
        newTab: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hrefUrl() {
            return this.href || this.to
        },

        hasTrackingCallback() {
            return this.$listeners && this.$listeners.trackingCallback
        },

        target() {
            return this.newTab ? '_blank' : '_self'
        },
    },
    methods: {
        trackClick(event) {
            if (!this.tracking && !this.hasTrackingCallback) {
                return
            }

            if (this.hasTrackingCallback) {
                this.$emit('trackingCallback')

                return
            }

            const [name, payload] = this.tracking

            track(name, payload)
        },
    },
}
